type LinkItem = {
    title: string;
    subTitle: string;
    href: string;
    type?: string;
    lang?: string;
};

export const navigationMenu: LinkItem[] = [
    {
        title: 'All cases',
        subTitle: 'List of all cases',
        href: '/',
    },
    {
        title: 'Ситуации классика',
        subTitle: 'Список классических ситуаций',
        href: '/classic/ru',
        type: 'classic',
        lang: 'ru',
    },
    {
        title: 'Ситуации экспресс',
        subTitle: 'Список экспресс ситуаций',
        href: '/quick/ru',
        type: 'quick',
        lang: 'ru'
    },
    {
        title: 'Ситуации командные',
        subTitle: 'Список командных ситуаций',
        href: '/team/ru',
        type: 'team',
        lang: 'ru'
    },
    {
        title: 'Classic Cases',
        subTitle: 'List of classic cases',
        href: '/classic/en',
        type: 'classic',
        lang: 'en'
    },
    {
        title: 'Quick Cases',
        subTitle: 'List of quick cases',
        href: '/quick/en',
        type: 'quick',
        lang: 'en'
    },
    {
        title: 'Team Cases',
        subTitle: 'List of team cases',
        href: '/team/en',
        type: 'team',
        lang: 'en'
    },
];
